<template>
  <section class="section">
    <div class="container">
      <settings-tabs/>
      <router-view/>
    </div>
  </section>
</template>

<script>
import SettingsTabs from '@/components/SettingsTabs'

export default {
  name: 'ControlPanel',
  components: { SettingsTabs }
}
</script>
